import type { I18nLocale } from "@/modules/i18n/types"
import type { Slug } from "@/modules/jobSearchPrefiltered/types"
import type { FunctionComponent } from "react"

import { Text } from "@jobteaser/spark/components/Text"

import { PREFILTERED_BASENAME } from "@/modules/jobSearchPrefiltered/constants"
import { Link } from "@/modules/routing/components/Link"

import styles from "./Tag.module.css"

export type TagProps = {
  slug: Slug
  label: string
  locale: I18nLocale
}

export const Tag: FunctionComponent<TagProps> = ({ slug, label, locale }) => {
  return (
    <Link
      className={styles.tag}
      href={`/${locale}/${PREFILTERED_BASENAME}/${slug.slug}`}
      key={slug.slug}
      data-testid="PrefilteredJobSearch-NetlinkingBlock__internalLink"
    >
      <Text className={styles.label} title={label} variant="body2" weight="semiBold">
        {label}
      </Text>
    </Link>
  )
}
